<mat-dialog-content class="mat-typography dialog-content">
	<app-goals *ngIf="id" [id]="id" (completed)="onNoClick()"></app-goals>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<!-- <button mat-button color="warn" class="left" (click)="onDeleteQuiz()">Delete</button> -->
  <button mat-button  class="right" (click)="onNoClick()">Cancel</button>
</mat-dialog-actions>